var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNp3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_196_1431)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_196_1431",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_196_1431",
    transform: "scale(0.0357143)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_196_1431",
    width: 28,
    height: 28,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAACe0lEQVRIDdWWsZHbMBBFN3HkzLFCVyAXQIwCuwGWoRauiOtEMWtwcoGoSH1c6Hmf+JwlRA2lsy+wZjCEwN39f/8uAEb8D7/fP+IL49O4ZoC3n/F17OKFwZx35xLfGf+EBEEvJY4M5gQeS7wzND/EfixxGksM4yH2f531W4mdgpUYmLcZnkv0iUDvjJ/KFmPYWjLmDAdhnUE2IlQlJuNLF6/nLq5IbvvNrAUwSdZvGkeEA9tPcndxhcAj/gF7pDr/im/ZQRlQyyrtpUTJNsyr/O9kaiI5xmKOA8GyIeAwB0wkurgKaGqegTlB7CPQZJ9LsQDDgU5su01g1IROPMQeAEhgDwkTYt2gBNbWmbp5WJX2HiDGgKkZGonNGCIM/ydWAjytAmIM2ywphmp7JLoDlkEkdbUjjn1z5rZ3o0giLyIxLe46eX3tWZWYa4oNCbDOc+GzkKAeWXIosXPNFg53/uTgqi37kzq2e/IuYGW4KkkDCoDIldiJrM/cNUAbZIasEYCuZb2Jf/MX2yr/0S+VZT2xvDY/leW0f3oKzgsa5RFJ097rTY54xLmpnxExrKf+jeZt29tnJtXFK74GY10+JWii42pJKuDgIjsoxpK2Ht7YiX2tWQ180oGd9uImIEEw0vFFtmnvmWGuqWuW7bN8IsVe3Ni/OhM5VeodN2SHXFPqo33aNBQ2kMjgVmv1qRNiOjt1q5Mphs5y1Skt6nRhKyR50+vbqaTt4kUtzmWKvP6GSXvMGcg+XdCsA/YowZmBm2NmXC9kBTSBevbmT5A5wEcnsK0BdT3Vbp4/oiBALRnO+qNY8kMaQJxxmyFG2Dwt4TOsPh3gGTJbtn8ALbjZt7zsgC8AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNp3);
export default __webpack_public_path__ + "static/media/np3.5b3aeb9cee016de2d52e6cfdea1da289.svg";
export { ForwardRef as ReactComponent };